import { Domain } from "core/types/domain.types";

export const transformDomain = (data: any): Domain => ({
  id: data?.id,
  domain: data?.domain,
  name: data?.name,
  email: data?.email,
  pec: data?.pec,
});
